// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2-HYc","author":"Table_author__1J5Wg","authorImage":"Table_authorImage__20jtJ","unreadRow":"Table_unreadRow__3LXMz"};